module.exports = __webpack_public_path__ + "fonts/6c7f0484bcb68582fb4b4f7b1edf1f99.svg";